// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CreatorAvatar_wrapper__KgSjX","badge":"CreatorAvatar_badge__uesAr","_big":"CreatorAvatar__big__fV9KV"};